/* NOTE: custom scripts added by OMA agency <3 */

/* --- NAVBAR SCROLL COLOR CHANGE --- */
(function () {
  var header = document.querySelector(".site-header");
  var infoBanner = document.querySelector(".info-banner");

  if (!header) return;

  var gradient = header.querySelector(".site-header__gradient");

  function update() {
    var isHome = document.body.classList.contains("template-index");
    var threshold = window.innerHeight * (isHome ? 0.3 : 0.01);
    var scrolled = window.scrollY;

    if (scrolled < threshold) {
      header.classList.remove("site-header--scrolled-past-hero");
    } else {
      header.classList.add("site-header--scrolled-past-hero");
    }

    if (gradient) {
      var fadeRange = window.innerHeight * 0.3;
      var opacity = Math.max(
        0,
        Math.min(1, (scrolled - threshold) / fadeRange),
      );
      gradient.style.opacity = opacity;
    }

    if (infoBanner) {
      var bannerHeight = infoBanner.offsetHeight + 20;
      var startAt = threshold;
      var bannerProgress = Math.min(1, Math.max(0, (scrolled - startAt) / 120));
      var headerProgress = Math.min(1, Math.max(0, (scrolled - startAt) / 200));
      infoBanner.style.transform =
        "translateY(-" + bannerHeight * bannerProgress + "px)";
      infoBanner.style.pointerEvents = bannerProgress >= 1 ? "none" : "";
      header.style.transform =
        "translateY(-" + bannerHeight * headerProgress + "px)";
    }
  }

  update();
  window.addEventListener("scroll", update, { passive: true });

  /* --- MENU OR CART OPEN: freeze header at top, hide banner --- */
  new MutationObserver(function () {
    var bodyCls = document.body.classList;
    if (bodyCls.contains("menu-open") || bodyCls.contains("cart-open")) {
      if (infoBanner) infoBanner.style.transform = "translateY(-999px)";
      header.style.transform = "none";
    } else {
      update();
      /* Close sub-drawer when menu closes */
      var sub = document.querySelector(".menu-drawer__sub");
      if (sub) {
        sub.classList.remove("open");
        sub.setAttribute("aria-hidden", "true");
      }
      var toggle = document.querySelector(".menu-drawer__shop-toggle");
      if (toggle) toggle.setAttribute("aria-expanded", "false");
    }
  }).observe(document.body, { attributes: true, attributeFilter: ["class"] });
})();

/* --- MENU SHOP SUB-DRAWER --- */
(function () {
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest(".menu-drawer__shop-toggle");
    var back = e.target.closest(".menu-drawer__sub-back");

    if (toggle) {
      var sub = toggle
        .closest("menu-drawer")
        .querySelector(".menu-drawer__sub");
      sub.classList.add("open");
      sub.setAttribute("aria-hidden", "false");
      toggle.setAttribute("aria-expanded", "true");
    }

    if (back) {
      var sub = back.closest(".menu-drawer__sub");
      sub.classList.remove("open");
      sub.setAttribute("aria-hidden", "true");
      var toggle = back
        .closest("menu-drawer")
        .querySelector(".menu-drawer__shop-toggle");
      if (toggle) toggle.setAttribute("aria-expanded", "false");
    }
  });
})();

/* --- COLLECTION FILTER --- */
(function () {
  function applyFilter(filter) {
    document.querySelectorAll(".collection-filter-btn").forEach(function (b) {
      b.classList.toggle(
        "collection-filter-btn--active",
        b.getAttribute("data-filter") === filter
      );
    });

    document.querySelectorAll("[data-category]").forEach(function (section) {
      if (filter === "all") {
        section.hidden = false;
      } else {
        section.hidden = section.getAttribute("data-category") !== filter;
      }
    });
  }

  function filterFromUrl() {
    var params = new URLSearchParams(window.location.search);
    return params.get("filter") || "all";
  }

  document.addEventListener("click", function (e) {
    var link = e.target.closest(".collection-filter-btn");
    if (!link) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    e.preventDefault();

    var filter = link.getAttribute("data-filter") || "all";
    var url = new URL(window.location.href);
    if (filter === "all") {
      url.searchParams.delete("filter");
    } else {
      url.searchParams.set("filter", filter);
    }
    window.history.pushState({ filter: filter }, "", url);

    applyFilter(filter);
  });

  window.addEventListener("popstate", function () {
    applyFilter(filterFromUrl());
  });

  document.addEventListener("DOMContentLoaded", function () {
    applyFilter(filterFromUrl());
  });
})();

// --- PRODUCT SLIDER: Swiper main + thumbs gallery ---
document.addEventListener("DOMContentLoaded", function () {
  var mainSlider = document.querySelector(".main-swiper");
  var thumbsSlider = document.querySelector(".thumbs-swiper");
  if (mainSlider && thumbsSlider && window.Swiper) {
    var thumbsSwiper = new Swiper(thumbsSlider, {
      spaceBetween: 8,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
      watchOverflow: true,
      breakpoints: {
        600: { slidesPerView: 6 },
        900: { slidesPerView: 8 },
      },
    });
    var mainSwiper = new Swiper(mainSlider, {
      spaceBetween: 0,
      slidesPerView: 1,
      autoHeight: true,
      navigation: {
        nextEl: ".main-swiper .swiper-button-next",
        prevEl: ".main-swiper .swiper-button-prev",
      },
      thumbs: {
        swiper: thumbsSwiper,
      },
      loop: false,
    });

    // autoHeight measures the active slide once, at init — but the slide's
    // images are lazy (insertImg in functions.js sets src from data-src when
    // they scroll near), so it measures the placeholder and never re-measures.
    // Any slide that ends up shorter than its placeholder then leaves the
    // slider's grey background showing beneath the photo. Re-measure as each
    // image lands. Harmless on sliders whose box height is fixed either way.
    mainSlider.querySelectorAll("img").forEach(function (img) {
      img.addEventListener("load", function () {
        mainSwiper.updateAutoHeight();
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var crunchyWords = document.querySelectorAll(
    ".list-products__crunchy-doodle__word",
  );
  if (!crunchyWords.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-spinning");
        } else {
          entry.target.classList.remove("is-spinning");
        }
      });
    },
    { threshold: 0.3 },
  );

  crunchyWords.forEach(function (el) {
    observer.observe(el);
  });
});
